import API_URLS from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";


  const getAnnouncements = (data) => {
    return ApiHelper.postRequest(API_URLS.GET_ANNOUNCEMENTS, data);
  };

  const add_Announcement = (fields) => {
    return ApiHelper.postRequest(API_URLS.INSERT_ANNOUNCEMENT, fields);
  };
  const add_Baa = (fields) => {
    return ApiHelper.postRequest(API_URLS.INSERT_BAA, fields);
  };
  const get_Baa = () => {
    return ApiHelper.postRequest(API_URLS.GET_BAA);
  };

  const getBAASignedByClinicId = (params) => {
    return ApiHelper.postRequest(API_URLS.Get_Baa_Acknowledgement_By_Clinic_Id+(params.masterClinicId));
  };
  const GetBaaAcknowledgementHistory = () => {
    return ApiHelper.getRequest(API_URLS.GET_BAA_ACKNOWLEDGEMENT_HISTORY);
  };
  const update_Baa = (fields) => {
    return ApiHelper.postRequest(API_URLS.UPDATE_BAA_DATES, fields);
  };

  const getAnnouncementById = (id) => {
    return ApiHelper.getRequest(`${API_URLS.GET_ANNOUNCEMENT_BY_ID}?id=${id}&regionId=0`);
  };

  const deleteAnnouncement = (id) => {
    return ApiHelper.deleteRequest(`${API_URLS.DELETE_ANNOUNCEMENT}?id=${id}&regionId=0`);
  };

  const updateAnnouncement = (id,data) => {
    data['announcementId']=id;
    return ApiHelper.postRequest(API_URLS.UPDATE_ANNOUNCEMENT, data);
  };
  
  export const AnnouncementServices = {
    getAnnouncements,
    add_Announcement,
    getAnnouncementById,
    updateAnnouncement,
    deleteAnnouncement,
    add_Baa,
    get_Baa,
    update_Baa,
    GetBaaAcknowledgementHistory,
    getBAASignedByClinicId
  };